export default __webpack_public_path__ + "static/media/icon-facebook-2.90af3143.svg";